import { CSSProperties } from '@linaria/atomic';
import { cx } from '@linaria/core';
import "./Dot.linaria.module.css!=!./Dot?./Dot.linaria.module.css?css=H4sIAAAAAAAAA42U226jMBCG7/sU3ERtpCXC5EBCb1baB7GG2IQJPhDbHBLUd1+lxCRklVVBQhr7m3+s4fcswEmaRJTwA+SbTZ/pLrQFMN2mUXB9GzAfYViA0GGLzBXz20oG+/JgdK3Y/PPrbXGVWR8psTZDVvSZNoyb0ADD2qbraOaZY0aPS7Hrkl6iGhTTQXCMRz0eU8LK9QmhLzgeCncjh2DEmjM1l9qZuH+Um0o5Q8n5DGJremdA2Vwbmdo9CP5B5sH3kgDHP9bR7Fewjmb3xJaSZFW7WN4TQ23wgColUTQLrh8Py5Jap9rttq+0RYdapZBZLWrHPbKzlLiuxUb0DG0l4Jzmgnd+e4O0FYVm2GfaOS1TshrV2xMts0Q1l/4SomK8S4nfUkufZr779JAlNEVW5YfVNOorYAzVIXS6SqMR5hOYP8O3Q935csKXz7zguXugxYQWz/Rw9hEvVx7QFezRne9bsqRFLOVxc2+04QIcNmOjY0bbmIDGadTffRvutdDmZhdowIEJM2AHHuo8F6j4/EEr03Fsk2n0My01kUqET/5Bxu+Sn3MDktvAYFUJHvRvwcMTzZ4Wrs/d38Fg8GixnX/+g/meBmS69zWJvi3+gxrxYvW/GtGrGr7BF7ftlrfLk6aQO25e3yFyltUuOt3c4fGJkbc7zC/FEzF1IymKlWssJdqedNx4aJghj7eaROuVsOIZvI2kRzLRDqTyQ9CDL2chOWZ1ETWUVBK0PHkeFEoYPD38dLKIbYAqR4WOBxwsD1GFunZeiBEiraFdXDhbTsumpOoCqwWyYF8bw5X7c/XdeITdcns8ddfhmLN94nP3WjmuXPr+/vn19heINI4KIwYAAA=="
const stylesRoot = "atm_70_1egaf66 atm_5j_1ssbidh atm_jb_j3l9x7 atm_e2_1dk5qia atm_vy_rzutr2";
const stylesDot = "atm_tr_1yyal8r atm_tw_174ut2m atm_mk_stnw88 atm_9s_1txwivl atm_6i_wlhodi atm_wq_kb7nvz atm_n3_wlhodi atm_lo_idpfg4 atm_le_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4";
const stylesPlainDot = "atm_9s_1txwivl atm_lo_idpfg4 atm_le_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4";
const stylesDisabled = "atm_k4_idpfg4";
const inlineStyles = "atm_mk_h2mmj6";
const stylesOffline = "atm_2d_w21aoi";
const stylesBadge = "atm_2d_bo22s7 atm_7l_bo22s7";
export const stylesBroadcasting = "atm_2d_bo22s7 atm_7l_bo22s7 atm_2zt8x3_stnw88 atm_1ymp90q_idpfg4 atm_89ifzh_idpfg4 atm_1hh4tvs_1osqo2v atm_1054lsl_1osqo2v atm_7otamn_1ssbidh atm_1jbuh0v_1pmaomq atm_d11msr_x2htsk atm_1938jqx_1yyfdc7";
type DotProps = {
  isBroadcasting?: boolean;
  isOffline?: boolean;
  disableBadge?: boolean;
  inline?: boolean;
  plain?: boolean;
  haloWidth?: number;
  dotSize?: number;
};
const Dot = (props: DotProps) => {
  const {
    isBroadcasting,
    disableBadge,
    inline,
    isOffline,
    plain,
    haloWidth = 2,
    dotSize = 8
  } = props;
  const getStyles = () => {
    if (disableBadge) {
      return stylesDisabled;
    }
    if (isBroadcasting) {
      return stylesBroadcasting;
    }
    if (isOffline) {
      return stylesOffline;
    }
    return stylesBadge;
  };
  const stateClassName = getStyles();
  return <div data-testid="Badge__DotIcon" className={cx(stylesRoot, plain && stylesPlainDot, !plain && stylesDot, stateClassName, inline && inlineStyles)} style={{
    '--halo-width': haloWidth + 'px',
    '--min-width': dotSize + 'px',
    '--height': dotSize + 'px',
    '--width': dotSize + 'px'
  } as CSSProperties} />;
};
export default Dot;